module.exports = __webpack_public_path__ + "static/media/CC20-AP100-12-FAICO.03fb322f.pdf";